// src/services/TokenManager.ts
import { Auth } from '@/services/AuthService';
import * as Sentry from '@sentry/vue';
export class TokenManager {
    static EXPIRY_MARGIN_SECONDS = 30;
    static tokens = {};
    static scopesByResource = {
        campus: 'openid profile email Campus.Fahrschueler Campus.SignalR roles offline_access Fso.Elbe.Api Fso.Cloud.Api cloudapi',
        cockpit: 'openid profile offline_access Cockpit.API',
        learn: 'openid profile offline_access Learn.API',
        college: 'openid profile offline_access College.API'
    };
    static async getToken(resource) {
        const token = this.tokens[resource];
        if (token) {
            console.log(`[TokenManager] 🔹 Using cached token for ${resource}`);
            Sentry.addBreadcrumb({
                category: 'tokenmanager',
                level: 'debug',
                message: `Using cached token`,
                data: { resource, expiresAt: token.expiresAt }
            });
            return token;
        }
        // Nu avem token → cerem token nou
        console.log(`[TokenManager] 🔄 Requesting NEW token for ${resource}`);
        Sentry.addBreadcrumb({
            category: 'tokenmanager',
            level: 'debug',
            message: `Requesting new token`,
            data: { resource }
        });
        const scopes = this.scopesByResource[resource];
        try {
            const { accessToken, expiresAt } = await Auth.getNewAccessTokenForScopes(scopes);
            this.tokens[resource] = {
                accessToken,
                expiresAt
            };
            console.log(`[TokenManager] 💾 Cached new token for ${resource}`);
            Sentry.addBreadcrumb({
                category: 'tokenmanager',
                level: 'debug',
                message: 'New token cached',
                data: { resource, expiresAt }
            });
            return this.tokens[resource];
        }
        catch (err) {
            console.error('[TokenManager] ❌ Failed to get new access token:', err);
            Sentry.captureException(err, {
                extra: {
                    resource,
                    reason: 'Auth.getNewAccessTokenForScopes_failed'
                }
            });
            throw err;
        }
    }
    static invalidate(resource) {
        console.log('Invalidate token for', resource);
        const tokenExists = !!this.tokens[resource];
        delete this.tokens[resource];
        console.warn(`[TokenManager] 🗑️ Invalidated token for ${resource}`);
        Sentry.addBreadcrumb({
            category: 'tokenmanager',
            level: 'warning',
            message: `Token invalidated`,
            data: { resource, existed: tokenExists }
        });
    }
    static clearCache() {
        Sentry.addBreadcrumb({
            category: 'tokenmanager',
            level: 'debug',
            message: 'Token cache cleared'
        });
        console.log('[TokenManager] 🧹 Token cache cleared');
        this.tokens = {};
    }
}
